import { Link } from 'react-router-dom'
import { formatRupiah } from '@/lib/utils'
import type { Produk } from '@/types'

const BADGE: Record<string, { label: string; cls: string }> = {
  sewa: { label: 'Sewa',  cls: 'bg-purple-600' },
  jasa: { label: 'Jasa',  cls: 'bg-emerald-600' },
  tour: { label: 'Tour',  cls: 'bg-orange-500'  },
}

export default function ProductCard({ product }: { product: Produk }) {
  const badge = BADGE[product.tipe]
  const hasRange = product.harga_max != null && product.harga_max > product.harga
  const isSewa   = product.tipe === 'sewa'

  return (
    <Link
      to={`/produk/${product.id}`}
      className="bg-white rounded-xl shadow-sm overflow-hidden hover:shadow-md transition-shadow"
    >
      <div className="bg-blue-50 aspect-square flex items-center justify-center text-5xl relative">
        {product.gambar_url ? (
          <img src={product.gambar_url} alt={product.nama} className="w-full h-full object-cover" />
        ) : (
          '🎒'
        )}
        {badge && (
          <span className={`absolute top-2 left-2 text-xs ${badge.cls} text-white px-1.5 py-0.5 rounded-full font-medium`}>
            {badge.label}
          </span>
        )}
      </div>
      <div className="p-3 space-y-1">
        <p className="text-sm font-medium text-gray-800 line-clamp-2">{product.nama}</p>
        <div>
          {hasRange ? (
            <p className="text-blue-600 font-semibold text-sm">
              {formatRupiah(product.harga)} – {formatRupiah(product.harga_max!)}
              <span className="text-xs text-gray-400 font-normal ml-1">*estimasi</span>
            </p>
          ) : (
            <p className="text-blue-600 font-semibold text-sm">{formatRupiah(product.harga)}</p>
          )}
          {isSewa && product.sewa_per_hari && <p className="text-xs text-gray-400">per hari</p>}
        </div>
        {product.stok === 0 && product.tipe !== 'jasa' && (
          <span className="inline-block text-xs bg-red-100 text-red-500 px-2 py-0.5 rounded-full">
            Habis
          </span>
        )}
      </div>
    </Link>
  )
}
